import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';

class FormNested extends Component {

  onChange(options) {
    let objectValues = this.props.values || [];
    let result = [];
    let name = this.props.nestedName;
    var objIds = [];
    var selectedVals = options ? options.map(option => option.value) : [];

    Array.from(objectValues).forEach(function(entry) {
      var e = parseInt(entry[name]);
      if (e) {
        if (selectedVals.indexOf(e) > -1) {
          entry['_destroy'] = false;
        }
        else {
          entry['_destroy'] = true;
        }
        result.push(entry);
        objIds.push(parseInt(entry[name]));
      }
    });

    var newIds = selectedVals.filter(function(entry) {
      return objIds.indexOf(entry) < 0;
    });

    newIds.forEach(function(entry) {
      result.push({'_destroy': false, 'id': null, [name]: parseInt(entry)});
    });

    this.props.onChange(result);
  }

  options() {
    return this.props.options.map(option => {
      return {label: option[0], value: option[1], disabled: this.isDisabledOptions(option)}
    })
  }

  isDisabledOptions(option) {
    if (this.props.availableOptions) {
      var disabled = true;
      this.props.availableOptions.forEach(o => {
        if (JSON.stringify(o) === JSON.stringify(option)) {
          disabled = false
        }
      });
      return disabled;
    }
  }

  isDisabledInput() {
    if (this.props.availableOptions) {
      var disabled = false;
      var values = this.props.values || [];
      Array.from(values).forEach(value => {
        if (this.props.availableOptions.filter(o => o[1] == value.location_id).length == 0) {
          disabled = true
        }
      });

      return disabled
    }
  }

  values() {
    const vals = this.props.values || [],
      name = this.props.nestedName,
      options = this.options();
    let result = [];
    Array.from(vals).forEach(val => {
      const notDestroy = typeof val._destroy === 'string' ? val._destroy != 'true' : !val._destroy
      if( notDestroy ) {
        const option = options.find(o => o.value == parseInt(val[name]));
        if (option) {
          result.push(option);
        }
      }
    });
    return result;
  }

  render() {
    return (
      <div className="fluid" id={this.props.name}>
        <Select placeholder={this.props.placeholder}
                isMulti
                value={this.values()}
                onChange={this.onChange.bind(this)}
                options={this.options()}
                isDisabled={this.isDisabledInput()}
        />
      </div>
    );
  }
};

FormNested.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array,
  availableOptions: PropTypes.array,
  nestedName: PropTypes.string.isRequired,
  values: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string
};

FormNested.defaultPorps = {
  placeholder: ''
};

export default FormNested;
